// extracted by mini-css-extract-plugin
export default {"containerText":"TabUno_containerText__Mq2rE","textField":"TabUno_textField__SQnfa","textFieldDisabled":"TabUno_textFieldDisabled__tS3wq"};